var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGetPercentagePartnersDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3 12C9.31178 12 7.7 13.6118 7.7 15.6V32.4C7.7 34.3877 9.31294 36 11.3017 36H37.7C39.6882 36 41.3 34.3882 41.3 32.4V31.8C41.3 31.1373 41.8373 30.6 42.5 30.6C43.1627 30.6 43.7 31.1373 43.7 31.8V32.4C43.7 35.7137 41.0137 38.4 37.7 38.4H11.3017C7.98858 38.4 5.3 35.7143 5.3 32.4V15.6C5.3 12.2863 7.9863 9.6 11.3 9.6C11.9627 9.6 12.5 10.1373 12.5 10.8C12.5 11.4627 11.9627 12 11.3 12ZM17.3 10.8C17.3 10.1373 17.8373 9.6 18.5 9.6H37.6979C41.011 9.6 43.7 12.2856 43.7 15.6V17.4C43.7 18.0627 43.1627 18.6 42.5 18.6C41.8373 18.6 41.3 18.0627 41.3 17.4V15.6C41.3 13.6124 39.6868 12 37.6979 12H18.5C17.8373 12 17.3 11.4627 17.3 10.8Z",
    fill: "#15D4B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4422 14.9916C10.9187 14.5309 11.6783 14.5437 12.139 15.0202L14.8558 17.8303L17.6659 15.1135C18.1424 14.6528 18.9021 14.6657 19.3627 15.1421C19.8234 15.6186 19.8106 16.3783 19.3341 16.839L16.524 19.5558C15.5711 20.4771 14.0517 20.4514 13.1304 19.4985L10.4135 16.6884C9.95289 16.2119 9.96571 15.4522 10.4422 14.9916Z",
    fill: "#15D4B6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9 18C14.2373 18 13.7 17.4627 13.7 16.8L13.7 7.2C13.7 6.53726 14.2373 6 14.9 6C15.5627 6 16.1 6.53726 16.1 7.2L16.1 16.8C16.1 17.4627 15.5627 18 14.9 18Z",
    fill: "#15D4B6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3 25.1824C22.6373 25.1824 22.1 24.6452 22.1 23.9824C22.1 20.6784 24.7784 18 28.0824 18L35.9 18C36.5627 18 37.1 18.5373 37.1 19.2C37.1 19.8627 36.5627 20.4 35.9 20.4L28.0824 20.4C26.1039 20.4 24.5 22.0039 24.5 23.9824C24.5 24.6452 23.9627 25.1824 23.3 25.1824Z",
    fill: "#15D4B6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5 22.2C43.1627 22.2 43.7 22.7373 43.7 23.4V23.9824C43.7 27.2961 41.0137 29.9824 37.7 29.9824H29.9C29.2373 29.9824 28.7 29.4452 28.7 28.7824C28.7 28.1197 29.2373 27.5824 29.9 27.5824H37.7C39.6882 27.5824 41.3 25.9706 41.3 23.9824V23.4C41.3 22.7373 41.8373 22.2 42.5 22.2Z",
    fill: "#15D4B6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3 22.8C22.6373 22.8 22.1 23.3373 22.1 24C22.1 27.304 24.7784 29.9824 28.0824 29.9824H35.9C36.5627 29.9824 37.1 29.4452 37.1 28.7824C37.1 28.1197 36.5627 27.5824 35.9 27.5824H28.0824C26.1039 27.5824 24.5 25.9785 24.5 24C24.5 23.3373 23.9627 22.8 23.3 22.8Z",
    fill: "#15D4B6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5 16.2C43.1627 16.2 43.7 16.7373 43.7 17.4C43.7 19.0628 42.3441 20.4 40.6931 20.4L34.7 20.4C34.0373 20.4 33.5 19.8627 33.5 19.2C33.5 18.5373 34.0373 18 34.7 18L40.6931 18C41.0305 18 41.3 17.7254 41.3 17.4C41.3 16.7373 41.8373 16.2 42.5 16.2Z",
    fill: "#15D4B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGetPercentagePartnersDetails);
export default __webpack_public_path__ + "static/media/iconGetPercentagePartnersDetails.f7a83e0bbf68c515f2fa1bf0f5b6009d.svg";
export { ForwardRef as ReactComponent };